import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { inlinePlayerWrapperStyles, inlinePlayerClassName } from './inlinePlayerWrapperStyles';
import { VcMediaWrapperProps } from '@atlaskit/react-ufo/vc-media';
export var InlinePlayerWrapper = function InlinePlayerWrapper(props) {
  var testId = props.testId,
    selected = props.selected,
    dimensions = props.dimensions,
    onClick = props.onClick,
    innerRef = props.innerRef;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    jsx("div", _extends({
      id: "inlinePlayerWrapper",
      "data-testid": testId
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      ,
      className: inlinePlayerClassName
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      ,
      css: inlinePlayerWrapperStyles({
        selected: selected,
        dimensions: dimensions
      }),
      onClick: onClick,
      ref: innerRef
    }, VcMediaWrapperProps), props.children)
  );
};